import API from '../../js/libs/API'

export default {
  getAllShiftArea,
  getAllDispatchArea,
  getSingleDispatchArea,
  getSingleSchedualedArea,
}
function getAllShiftArea() {
  /* 1. 下載所有排班區
        2. 存在localStorage
            1. ShiftAreaArray => 標記所有排班站localstorage位置
            2. schedualed-(id) => 標記排班站localstorage位置,以id區分
    */
  API.get(`/shift-area/all-area`)
    .then((res) => {
      let ShiftAreaArray = []
      let ShiftAreaCode = []
      let allArea = res.allArea
      for (let i = 0; i < allArea.length; i++) {
        localStorage.setItem(`schedualed-${allArea[i].id}`, allArea[i].kml)
        ShiftAreaArray.push(`schedualed-${allArea[i].id}`)
        ShiftAreaCode.push(allArea[i].identification_code)
      }
      localStorage.setItem(`SchedualAreaNumber`, ShiftAreaCode.join(','))
      localStorage.setItem(`ShiftAreaArray`, ShiftAreaArray.join(','))
    })
    .catch((err) => {
      console.log(err)
    })
}

function getAllDispatchArea() {
  /* 1. 下載所有派遣區
        2. 存在localStorage
            1. DispatchAreaArray => 標記所有派遣區localstorage位置
            2. dispatch-(id) => 標記派遣區localstorage位置,以id區分
    */
  API.get(`/dispatch-area/all-area`)
    .then((res) => {
      let DispatchAreaArray = []
      let DispatchAreaCode = []

      let allArea = res.allArea
      for (let i = 0; i < allArea.length; i++) {
        localStorage.setItem(`dispatch-${allArea[i].id}`, allArea[i].kml)
        DispatchAreaArray.push(`dispatch-${allArea[i].id}`)
        DispatchAreaCode.push(allArea[i].identification_code)
      }
      localStorage.setItem(`DispatchAreaNumber`, DispatchAreaCode.join(','))
      localStorage.setItem(`DispatchAreaArray`, DispatchAreaArray.join(','))
      return false
    })
    .catch((err) => {
      console.log(err)
    })
}

function getSingleDispatchArea(id) {
  API.get(`/dispatch-area/?id=${id}`)
    .then((res) => {
      if (res.err === '找不到檔案') return false

      localStorage.setItem(`dispatch-${res.result.id}`, res.kmlFile)
      return true
    })
    .catch((err) => {
      console.log(err)
    })
}
function getSingleSchedualedArea(id) {
  API.get(`/shift-area/?id=${id}`)
    .then((res) => {
      if (res.err === '找不到檔案') return false
      console.log(res)
      localStorage.setItem(`schedualed-${res.result.id}`, res.kmlFile)
      return true
    })
    .catch((err) => {
      console.log(err)
    })
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/updateKml.js